// extracted by mini-css-extract-plugin
export var border = "_8x-0";
export var borderSelected = "_8x-1";
export var check = "_8x-6";
export var circle = "_8x-2";
export var circleInner = "_8x-4";
export var circleInnerDisabled = "_8x-8";
export var description = "_8x-3";
export var horizontal = "_8x-b";
export var input = "_8x-5";
export var label = "_8x-9";
export var radioButton = "_8x-d";
export var radioButtonNoCenter = "_8x-e";
export var radioGroup = "_8x-a";
export var rightRadio = "_8x-f";
export var subcontent = "_8x-g";
export var uncheck = "_8x-7";
export var vertical = "_8x-c";